'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, Sparkles } from 'lucide-react';

export default function HomeNavbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const links = [
    { label: 'Campus', href: '/' },
    { label: 'Courses', href: '/course-catalog' },
    { label: 'AI Tutor', href: '/ai-tutor-builder' },
    { label: 'For Parents', href: '/parent-dashboard' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-card/95 backdrop-blur-sm border-b border-border">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center gap-6">
        <Link href="/" className="flex items-center gap-2 shrink-0">
          <AppLogo size={36} />
          <span className="font-extrabold text-lg text-foreground tracking-tight">JarvondisU</span>
        </Link>

        <div className="hidden md:flex items-center gap-1 ml-4">
          {links?.map((l) => (
            <Link
              key={`nav-home-${l?.label}`}
              href={l?.href}
              className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-all duration-150"
            >
              {l?.label}
            </Link>
          ))}
        </div>

        <div className="flex-1" />

        <div className="hidden md:flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="px-4 py-2 text-sm font-semibold text-foreground hover:bg-muted rounded-lg transition-colors"
          >
            Sign In
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground text-sm font-semibold rounded-lg btn-scale hover:bg-primary/90 transition-colors"
          >
            <Sparkles size={14} />
            Enter Campus
          </Link>
        </div>

        <button
          className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
          onClick={() => setMobileOpen((p) => !p)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden border-t border-border bg-card px-6 py-4 flex flex-col gap-2 fade-in">
          {links?.map((l) => (
            <Link
              key={`mobile-nav-${l?.label}`}
              href={l?.href}
              className="px-4 py-2.5 text-sm font-medium text-foreground hover:bg-muted rounded-lg transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              {l?.label}
            </Link>
          ))}
          <Link
            href="/sign-up-login-screen"
            className="mt-2 px-4 py-2.5 bg-primary text-primary-foreground text-sm font-semibold rounded-lg text-center"
            onClick={() => setMobileOpen(false)}
          >
            Enter Campus
          </Link>
        </div>
      )}
    </nav>
  );
}